<template>
  <div class="api-docs container">
    <div class="jumbotron">
      <h1>Vestbee API Docs</h1>
    </div>
    <api-endpoint
      v-for="endpoint in endpoints"
      :key="endpoint.path"
      :endpoint="endpoint"
    />
  </div>
</template>

<script>
import ApiEndpoint from './ApiEndpoint.vue'
import http from 'services/http'

export default {
  components: { ApiEndpoint },
  data: () => {
    return {
      endpoints: [],
    }
  },
  created() {
    this.fetchEndpoints()
  },
  methods: {
    async fetchEndpoints() {
      this.isFetchInProgress = true
      const response = await http.get('/api-docs')
      this.isFetchInProgress = false
      this.endpoints = response.data
    },
  },
}
</script>

<style lang="scss">
.api-docs {
  margin-top: 30px;
}
</style>
